<template>
  <button
    class="font-normal text-gray-600 whitespace-no-wrap border-t-4 border-transparent block flex flex-col items-center px-2 py-2 md:px-6 hover:no-underline focus:outline-none"
    role="tab"
    @click="selectTab(tabindex)"
    :id="buttonId"
    :aria-controls="titleKebab"
    :aria-selected="[selected ? true : false]"
    :class="[
      selected ? activeTabClass : inactiveTabClass,
      tabactive ? tabCanBeSelectedClasses : tabCantBeSelectedClasses
    ]"
  >
    <span class="hidden font-semibold md:block">
      <span v-if="tabactive === true"> {{ count }}</span>
      <span v-else class="relative">
        <img
          src="@/assets/images/coming_soon_text.svg"
          alt=""
          class="relative block m-auto w-6"
        />
      </span>
    </span>
    <span class="text-sm"> {{ title }} </span>
  </button>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    title: String,
    count: Number,
    selected: Boolean,
    tabindex: Number,
    tabactive: Boolean
  },
  data() {
    return {
      tabCanBeSelectedClasses: "hover:text-blue-700 hover:bg-blue-300",
      tabCantBeSelectedClasses: "cursor-default",
      activeTabClass: "bg-white border-blue-700 text-blue-700",
      inactiveTabClass: "border-transparent hover:border-transparent"
    };
  },
  computed: {
    buttonId() {
      return this.title.replace(/\s+/g, "-").toLowerCase();
    },
    titleKebab() {
      return this.buttonId + "-tab";
    }
  },
  methods: {
    ...mapMutations(["setCurrentTab"]),
    selectTab(tabIndex) {
      if (this.tabactive) {
        this.setCurrentTab({ index: tabIndex, clean: true });
      }
    }
  }
};
</script>
